import { Routes, Route, useNavigate } from "react-router-dom";
import Home from "./container/Home";
import Login from "./components/Login";
import { checkUserConnexion } from "./utils/fetchUSer";
import { useEffect, useState } from "react";
const App = () => {
  const navigate = useNavigate();
  const checkUser = checkUserConnexion();
  const [check, setCheck] = useState(false);
  useEffect(() => {
    console.log("connect:", checkUser);
    if (!checkUser) navigate("/login");
    setCheck(true);
  }, []);

  return (
    <Routes>
      {check && (
        <>
          <Route path="login" element={<Login />} />
          <Route path="/*" element={<Home />} />
        </>
      )}
    </Routes>
  );
};

export default App;
